module.exports = {"host":"","hostnlp":"http://172.20.44.193:5050"}


//////////////////
// WEBPACK FOOTER
// ./src/config/production.json
// module id = 10
// module chunks = 47